import { CheckboxGroupProps } from "antd/es/checkbox";

export const type_options: CheckboxGroupProps<string>["options"] = [
  { label: "Text", value: "S" },
  { label: "Boolean", value: "B" },
];
